import { Eye } from "lucide-react";
import { t } from "@/lib/i18n";

export default function PreviewBanner() {
  return (
    <div role="status" className="safe-top bg-[#FEF3C7] text-[#78350F] border-b border-[#F3D88F]" data-testid="preview-banner">
      <p className="safe-x max-w-7xl mx-auto flex items-center justify-center gap-2 py-1.5 text-xs font-medium tracking-wide text-center">
        <Eye className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        {t("preview.banner")}
      </p>
    </div>
  );
}
